import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, gt } from 'ember-truth-helpers';

interface GeneralDropdownsSidebarSignature {
  Args: {
    selectOption: unknown;
    sidebarLists: unknown;
  };
}

export default class GeneralDropdownsSidebar extends Component<GeneralDropdownsSidebarSignature> {
  @service declare router: Services['router'];

  @action
  // @ts-expect-error: Incorrect type
  handleSidebarLinkClick(linkto): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const selectedSidebarItem = this.args.sidebarLists
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      .flatMap((list) => list.options)
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      .find((option) => option.isSelected);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    linkto.onClick?.(selectedSidebarItem);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.redirectToRoute(linkto.route);
  }

  @action
  // @ts-expect-error: Incorrect type
  redirectToRoute(route): void {
    if (route) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.router.transitionTo(route);
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  selectSidebarOption(option): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!option.isDisabled) {
      // @ts-expect-error: Incorrect type
      this.args.selectOption(option);
    }
  }

  <template>
    {{! @glint-nocheck }}
    {{! template-lint-disable link-href-attributes require-presentational-children }}
    <div class="sidebar">
      {{#each @sidebarLists as |sidebarList index|}}
        {{#if sidebarList.title}}
          <div
            class="sidebar-option sidebar-option__title flex justify-between truncate
              {{if (gt index 0) 'top-divider'}}"
          >
            <span class="text-200--bold">{{sidebarList.title}}</span>
            {{#if sidebarList.linkto}}
              <a
                class="prism-link"
                data-event-id="datepicker-link"
                data-event-value={{sidebarList.linkto.route}}
                role="button"
                {{on
                  "click"
                  (fn this.handleSidebarLinkClick sidebarList.linkto)
                }}
              >
                {{sidebarList.linkto.title}}
              </a>
            {{/if}}

          </div>
        {{/if}}
        {{#each sidebarList.options as |option|}}
          <p
            class="sidebar-option sidebar-option__item flex flex-row truncate
              {{if option.isSelected 'selected'}}
              {{if option.isDisabled 'disabled'}}
              {{if
                (and sidebarList.title (gt @sidebarLists.length 1))
                'sidebar-with-title'
              }}"
            data-test-id={{option.id}}
            role="button"
            {{on "click" (fn this.selectSidebarOption option)}}
          >
            {{#if option.count}}
              {{t option.text count=option.count}}
            {{else}}
              {{t option.text}}
            {{/if}}

            {{#if (and option.isDisabled option.disabledText)}}
              <PrismTooltip @side="left" @text={{option.disabledText}} />
            {{/if}}
          </p>
        {{/each}}
      {{/each}}
    </div>
  </template>
}
